import { LineMoreHorizontal } from '@qr-front/icons/line-more-horizontal'
import { Button } from '@qr-front/ui/components/Button'
import { useSetAtom } from 'jotai'

import { TQrData } from '@/generator/shared'

import { selectColDef } from '../../columnsConfig'
import {
	mobileTableRowActionDialogAtom,
	mobileTableRowActionDialogTypeAtom,
	qrItemState,
} from '../../dialogsState'
import { TABLE_ROW_ACTION_TYPE } from '../../TableActions/Actions/actionOptions'
import { useRenderDisplayCell } from '../../utils/renderDisplayCell'
import { Name } from '../commonElements'

export const MobileHeader = ({ qrItem }: { qrItem: TQrData }) => {
	const setQrItem = useSetAtom(qrItemState)
	const setTableRowDialogState = useSetAtom(mobileTableRowActionDialogAtom)
	const setTableRowActionDialogTypeState = useSetAtom(
		mobileTableRowActionDialogTypeAtom,
	)

	const selectCheckbox = useRenderDisplayCell(selectColDef)

	const handleClickMore = () => {
		setQrItem(qrItem)
		setTableRowDialogState(true)
		setTableRowActionDialogTypeState(TABLE_ROW_ACTION_TYPE.More)
	}

	return (
		<div className="flex items-center gap-4">
			{selectCheckbox}
			<Name />
			<Button onClick={handleClickMore} visual="text">
				<LineMoreHorizontal />
			</Button>
		</div>
	)
}
